import {
    Dialog,
    DialogActions,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
    FluentProvider,
    Button
} from "@fluentui/react-components";
import { Dismiss24Regular } from '@fluentui/react-icons';
import * as React from "react";
import ThemeUtils from "../../../utility/ThemeUtils";

const styles = require("./NewShiftsDialog.scss");
const classNames = require("classnames/bind");

interface NewShiftsDialogProps {
  title: React.ReactNode;
  subtext?: string;
  content: React.ReactNode;
  actions: React.ReactNode;
  isOpen: boolean;
  onDismiss: () => void;
  modalType?: "modal" | "non-modal";
  ariaDescribedBy?: string;
  ariaLabel?: string;
  ariaLabelledBy?: string;
  closeOnOutsideClick?: boolean;
  customStyles?: {
    dialogSurface?: string;
    dialogBody?: string;
    dialogActions?: string;
    dialogTitle?: string;
    dialogContent?: string;
    dialogSubtext?: string;
    dialogBodyContent?: string;
  };
  showDismiss?: boolean;
}

export const NewShiftsDialogForDeleteRestoreTeam: React.FC<NewShiftsDialogProps> = ({
    title,
    subtext,
    content,
    actions,
    isOpen,
    onDismiss,
    modalType = "modal",
    ariaDescribedBy,
    ariaLabel,
    ariaLabelledBy,
    closeOnOutsideClick = false,
    customStyles = {
        dialogSurface: "",
        dialogBody: "",
        dialogActions: "",
        dialogTitle: "",
        dialogContent: "",
        dialogSubtext: "",
        dialogBodyContent: ""
    },
    showDismiss = false
}) => {
    const handleOpenChange = (event: any) => {
        // Only dismiss if closeOnOutsideClick is true or it's not an outside click
        if (closeOnOutsideClick || event.type !== "click") {
            onDismiss();
        }
    };
    return (
        // This div is used to prevent the focus leaving the dialog when the dialog is open
        <div onKeyDown={e => e.stopPropagation()}>
            <FluentProvider theme={ThemeUtils.getFluentV2ShiftTheme()}>
                <Dialog modalType={modalType} onOpenChange={handleOpenChange} open={isOpen}>
                    <DialogSurface
                        aria-describedby={ariaDescribedBy}
                        aria-label={ariaLabel}
                        aria-labelledby={ariaLabelledBy}
                        className={classNames(styles.dialogSurface, customStyles.dialogSurface)}>
                        <DialogBody className={classNames(styles.dialogBody, customStyles.dialogBody)}>
                            <div className={customStyles.dialogBodyContent}>
                                <div className={classNames(styles.headerContainer, customStyles.dialogTitle)}>
                                    {title !== undefined && title !== null && (
                                        <DialogTitle>
                                            {title}
                                        </DialogTitle>
                                    )}
                                    {showDismiss && (
                                        <div className={styles.dialogActionButton}>
                                            <Button
                                                appearance="subtle"
                                                aria-label="close"
                                                icon={<Dismiss24Regular />}
                                                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                                    e.stopPropagation();
                                                    onDismiss();
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                                {subtext && <div className={customStyles.dialogSubtext}>{subtext}</div>}
                                <DialogContent className={customStyles.dialogContent}>{content}</DialogContent>
                            </div>
                            <DialogActions className={classNames(styles.dialogActions, customStyles.dialogActions)}>
                                {actions}
                            </DialogActions>
                        </DialogBody>
                    </DialogSurface>
                </Dialog>
            </FluentProvider>
        </div>
    );
};